// Vuex connections module mutations types

export const FILL_LIST = 'FILL_LIST';
export const SET_FILTERING_CRITERIA = 'SET_FILTERING_CRITERIA';
export const SET_PAGE = 'SET_PAGE';
